import React from 'react';

/**
 * PremiumJourneyPrompt - Shown after first meal to educate about MIQ cycle
 * Promotes premium features while showing the value proposition
 */
const PremiumJourneyPrompt = ({
  show,
  onClose,
  onUpgrade,
  onCompleteProfile
}) => {
  if (!show) return null;
  
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '420px', textAlign: 'center' }}>
        {/* Celebration Header */}
        <div style={{ marginBottom: '20px' }}>
          <div style={{ fontSize: '48px', marginBottom: '12px' }}>🍽️✨</div>
          <h2 style={{ margin: '0 0 8px 0', fontSize: '20px' }}>Your Plate is Teaching Your Brain</h2>
          <p style={{ margin: 0, fontSize: '14px', color: 'var(--text-secondary)', lineHeight: '1.5' }}>
            That meal just made your MIQ a little smarter.
          </p>
        </div>
        
        {/* MIQ Status */}
        <div style={{ 
          background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.15) 0%, rgba(118, 75, 162, 0.15) 100%)',
          border: '1px solid rgba(102, 126, 234, 0.3)',
          borderRadius: '12px',
          padding: '16px',
          marginBottom: '20px'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px', marginBottom: '12px' }}>
            <span style={{ fontSize: '32px' }}>🧠</span>
            <div style={{ textAlign: 'left' }}>
              <p style={{ margin: 0, fontWeight: '600', fontSize: '14px' }}>MIQ: Learning</p>
              <p style={{ margin: 0, fontSize: '11px', color: 'var(--text-secondary)' }}>1 factor absorbed</p>
            </div>
          </div>
          <div style={{ 
            height: '6px', 
            background: 'rgba(255,255,255,0.1)', 
            borderRadius: '3px',
            overflow: 'hidden'
          }}>
            <div style={{ 
              width: '8%', 
              height: '100%', 
              background: 'linear-gradient(90deg, #667eea 0%, #764ba2 100%)',
              borderRadius: '3px'
            }} />
          </div>
          <p style={{ margin: '8px 0 0 0', fontSize: '11px', color: 'var(--text-secondary)', fontStyle: 'italic' }}>
            The more you feed it, the smarter it gets
          </p>
        </div>
        
        {/* The Cycle Explanation */}
        <div style={{ 
          background: 'linear-gradient(135deg, rgba(56, 239, 125, 0.1) 0%, rgba(17, 153, 142, 0.1) 100%)',
          border: '1px solid rgba(56, 239, 125, 0.3)',
          borderRadius: '12px',
          padding: '16px',
          marginBottom: '20px',
          textAlign: 'left'
        }}>
          <p style={{ margin: '0 0 12px 0', fontWeight: '600', fontSize: '14px', color: '#38ef7d', textAlign: 'center' }}>
            🔄 The SmartPlAIte Cycle
          </p>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', marginBottom: '12px' }}>
            <span style={{ fontSize: '20px' }}>🍽️</span>
            <span style={{ color: 'var(--text-secondary)' }}>→</span>
            <span style={{ fontSize: '20px' }}>🧠</span>
            <span style={{ color: 'var(--text-secondary)' }}>→</span>
            <span style={{ fontSize: '20px' }}>🎯</span>
            <span style={{ color: 'var(--text-secondary)' }}>→</span>
            <span style={{ fontSize: '20px' }}>🍽️</span>
          </div>
          <p style={{ margin: 0, fontSize: '12px', color: 'var(--text-secondary)', lineHeight: '1.5', textAlign: 'center' }}>
            <em>Your plate feeds your intelligence.<br/>Your intelligence guides your plate.</em>
          </p>
        </div>
        
        {/* Premium Benefits */}
        <div style={{ 
          background: 'rgba(255,255,255,0.03)',
          border: '1px solid rgba(255,255,255,0.1)',
          borderRadius: '12px',
          padding: '14px',
          marginBottom: '20px',
          textAlign: 'left'
        }}>
          <p style={{ margin: '0 0 10px 0', fontWeight: '600', fontSize: '13px', color: 'var(--text-primary)' }}>
            ✨ Accelerate your intelligence with Premium:
          </p>
          <ul style={{ margin: 0, paddingLeft: '18px', fontSize: '12px', color: 'var(--text-secondary)', lineHeight: '1.8' }}>
            <li>🧠 Deep personalization (SmartGoals)</li>
            <li>📊 Micronutrient tracking (vitamins, minerals)</li>
            <li>🍽️ AI-powered meal planning</li>
            <li>📈 MIQ history & progress insights</li>
          </ul>
        </div>
        
        {/* Actions */}
        <button 
          onClick={onUpgrade}
          className="btn-primary"
          style={{ 
            width: '100%', 
            padding: '14px',
            fontSize: '14px',
            background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
            marginBottom: '10px'
          }}
        >
          🚀 Unlock Full Intelligence
        </button>
        
        <button 
          onClick={onCompleteProfile}
          className="btn-secondary"
          style={{ width: '100%', padding: '12px', fontSize: '13px' }}
        >
          📋 Complete My Profile First
        </button>
        
        <button 
          onClick={onClose}
          style={{ 
            width: '100%',
            marginTop: '8px',
            padding: '8px',
            background: 'transparent',
            border: 'none',
            color: 'var(--text-secondary)',
            fontSize: '12px',
            cursor: 'pointer'
          }}
        >
          Keep building naturally
        </button>
      </div>
    </div>
  );
};

export default PremiumJourneyPrompt;
